import { DomSanitizer } from '@angular/platform-browser';
import {
  Component,
  OnInit,
  SecurityContext,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { AppConstant } from 'src/app/config/app.constant';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { AdminService } from 'src/app/services/admin.service';
import { environment } from '../../../environments/environment';

export class EmailTemplate {
  fromId: string;
  toId: string;
  subject: string;
  body: string;
}

@Component({
  standalone: false,
  selector: 'app-feedback-companies',
  templateUrl: './feedback-companies.component.html',
  styleUrls: ['./feedback-companies.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FeedbackCompaniesComponent implements OnInit {
  meetingNav: { index: string; name: string; link: string }[];
  emailList: string;
  show: boolean;
  token: string;
  url: string;
  memberDetail: any;
  subject: string;
  body: string;
  a: any;
  b: any;
  fromId: string;
  content: any;
  constructor(
    private router: Router,
    private appStateSrv: AppStateProvider,
    private sanitizer: DomSanitizer,
    private adminSrv: AdminService
  ) {}

  ngOnInit(): void {
    this.meetingNav = [
      {
        index: '1',
        name: 'Companies',
        link: 'companies/companies-list/feedback',
      },
    ];
    const route = {
      index: '1',
      name: 'Companies',
      link: 'companies/companies-list/feedback',
    };

    this.appStateSrv.setSideNavState(route);
    this.fromId = JSON.parse(
      localStorage.getItem(AppConstant.localStorage.userDetails)
    ).adminEmailId;
    console.log(this.fromId);
    this.emailList = localStorage.getItem(AppConstant.localStorage.emailId);
    this.subject = localStorage.getItem(AppConstant.localStorage.subject);
    this.body = this.sanitizer.sanitize(
      SecurityContext.HTML,
      localStorage.getItem(AppConstant.localStorage.body)
    );
  }

  sendemail() {
    if (this.content == null && this.content == undefined)
      return this.appStateSrv.showToast(
        'Please select any one of the Feedback Type'
      );

    //both not defined and not touched
    if (this.subject == undefined && this.body == undefined) {
      return this.appStateSrv.showToast(
        'Subject and Body can not be empty'
      );
    }
    // sub present but not body touched
    if (this.subject !== undefined && this.body == undefined) {
      if (this.subject.length > 4000) {
        return this.appStateSrv.showToast('subject too long!!');

      }
      if (this.subject.length !== undefined && this.subject.length !== 0) {
        return this.appStateSrv.showToast('Body can not be empty');

      }
      return this.appStateSrv.showToast('Subject and Body can not be empty');

    }
    //body present not sub touched
    if (this.body !== undefined && this.subject == undefined) {
      if (this.body.length !== undefined && this.body.length !== 0) {
        return this.appStateSrv.showToast('Subject can not be empty');

      }
      return this.appStateSrv.showToast('Subject and Body can not be empty');

    }
    if (this.subject !== undefined && this.body !== undefined) {
      if (this.subject.length == 0 && this.body.length == 0) {
        return this.appStateSrv.showToast('Subject and Body can not be empty');

      }
      if (this.subject.length == 0) {
       return this.appStateSrv.showToast('Subject can not be empty');

      }
      if (this.body.length == 0) {
       return this.appStateSrv.showToast('body can not be empty');
      }
    }

    let temp = new EmailTemplate();
    temp.fromId = this.fromId;
    temp.subject = this.subject;
    temp.body = this.body;
    temp.toId = this.emailList;

    this.adminSrv.sendEmail(temp).subscribe((response) => {
      console.log('response email ', response);
      history.back();
    });
  }

  cancel() {
    this.router.navigate(['companies/companies-list']);
  }

  onItemChange(event: any) {

    const baseUrl = `${environment.appBaseUrl}`;

    // this.content = (event == 'a' ? `${baseUrl}feedback/private-suite`: `${baseUrl}feedback/flexi-desk`) +'?email=' + this.emailList;
    this.content =`${baseUrl}feedback/private-suite` +'?email=' + this.emailList;
    document.getElementById('emailIdBody').getElementsByTagName('span' )[0].innerHTML="";
    document.getElementById('emailIdBody').getElementsByTagName('span' )[0].innerHTML = `<br><a href="${this.content}" target="_blank">Click to submit your feedback</a>`;
    this.body = document.getElementById('emailIdBody').innerHTML;
  }
}
